/**
 * Hardcoded milestone seed for Build Week 3.
 *
 * The Project + ProjectItem entities aren't yet migrated, so the CountdownBand
 * can't read from the DB. This file contains the milestones from
 * spec/bootstrap/projects-seed.json that have date deadlines, plus a few key
 * personal dates from spec/MINUTES.md.
 *
 * When projects-seed lands in a future migration, replace this with a query
 * that pulls ProjectItem WHERE kind='milestone' ORDER BY data->>'date'.
 */

export type Milestone = {
  id: string;
  title: string;
  date: string;       // ISO yyyy-mm-dd
  project: string;    // short label for the chip
  importance: "primary" | "secondary";
};

// Static for now. Sorted ascending by date. Filtered to dates in the future.
export const MILESTONES: Milestone[] = [
  {
    id: "cycling_tour_start",
    title: "Cycling tour: Zürich → Lourdes (start)",
    date: "2026-06-08",
    project: "Cycling Tour",
    importance: "primary",
  },
  {
    id: "berlin_visit",
    title: "Pack-out + Berlin visit",
    date: "2026-06-22",
    project: "Switzerland Exit",
    importance: "secondary",
  },
  {
    id: "fly_to_boston",
    title: "Travel ZRH → BOS",
    date: "2026-06-29",
    project: "Travel ZRH→BOS",
    importance: "primary",
  },
  {
    id: "mit_first_day",
    title: "MIT first day · Raines Group",
    date: "2026-07-01",
    project: "Boston Start",
    importance: "primary",
  },
  {
    id: "boston_apartment_lease",
    title: "Apartment lease starts",
    date: "2026-08-01",
    project: "Settling",
    importance: "secondary",
  },
  {
    id: "berlin_marathon",
    title: "Berlin Marathon — sub-2:50 attempt",
    date: "2026-09-27",
    project: "Marathon Build",
    importance: "primary",
  },
];

/** Closest N upcoming milestones from a given reference date (default: today). */
export function upcomingMilestones(
  refDate: Date = new Date(),
  n = 3,
): (Milestone & { daysUntil: number })[] {
  const today = new Date(refDate);
  today.setHours(0, 0, 0, 0);
  return MILESTONES
    .map((m) => {
      const d = new Date(m.date + "T00:00:00");
      const daysUntil = Math.round((d.getTime() - today.getTime()) / 86400000);
      return { ...m, daysUntil };
    })
    .filter((m) => m.daysUntil >= 0)
    .sort((a, b) => a.daysUntil - b.daysUntil)
    .slice(0, n);
}
